import React from "react";
import { parseFilter, stringifyFilter } from "../../utils";
import queryString from 'query-string';
import MenuAction from "../MenuAction/MenuAction";
import { useGlobalValue } from "../../state/GlobalProvider";
import Icon from "../Icon/Icon";
import styles from "./ListHeader.module.sass";
const ListHeader = props => {
  const {
    modifiers,
    header,
    sort,
    onCheckBoxChange,
    isAllSelected,
    checkbox,
    adjustStickyTop
  } = props;
  const {
    i18n,
    history,
    location,
    params
  } = useGlobalValue();
  const paramSort = sort ? parseFilter(sort) : [];
  const modifiersClasses = (modifiers || []).map(m => styles[m]).filter(m => m).join(" ");
  const updateSort = columnName => {
    const sortElementIndex = paramSort.findIndex(f => f.column === columnName);
    if (sortElementIndex !== -1) {
      switch (paramSort[sortElementIndex].order) {
        case "asc":
          {
            paramSort.splice(sortElementIndex, 1, {
              column: columnName,
              order: "desc"
            });
            break;
          }
        case "desc":
          {
            paramSort.splice(sortElementIndex, 1);
            break;
          }
        default:
          {
            break;
          }
      }
    } else {
      paramSort.push({
        column: columnName,
        order: "asc"
      });
    }
    const currentParams = {
      ...(params || {}),
      sort: stringifyFilter(paramSort)
    };
    if (!currentParams.sort) {
      currentParams.sort = undefined;
    }
    currentParams.page = undefined;
    currentParams.pageSize = undefined;
    history.replace({
      pathname: location.pathname,
      search: queryString.stringify(currentParams)
    });
  };
  return /*#__PURE__*/React.createElement("div", {
    className: `${styles["header"]} ${modifiersClasses}`
  }, header.map(({
    label,
    columnName,
    align,
    mobileHidden,
    sortable,
    width,
    basis,
    type,
    boldColumn = false
  }, index) => {
    const periods = new Array(12).fill(0);
    if (type && type === "heatMapPeriods") {
      return /*#__PURE__*/React.createElement("div", {
        key: index,
        className: styles["heat-map-title-container"]
      }, /*#__PURE__*/React.createElement("div", {
        className: styles["fiscal-year-container"]
      }, /*#__PURE__*/React.createElement("h5", null, i18n`${label}`)), /*#__PURE__*/React.createElement("div", {
        className: styles["periods-container"]
      }, periods.map((_, periodsIndex) => {
        return /*#__PURE__*/React.createElement("div", {
          className: styles["periods"],
          key: periodsIndex
        }, /*#__PURE__*/React.createElement("h5", null, periodsIndex > 12 ? `>${periodsIndex}` : periodsIndex + 1));
      })));
    }
    if (label[0] === "checkbox") {
      if (checkbox) {
        return /*#__PURE__*/React.createElement("div", {
          key: index,
          className: `${styles[`align-${align}`] || ""} ${mobileHidden ? "" : styles["mobile"]} ${width ? styles[width] || "" : ""}`
        }, /*#__PURE__*/React.createElement(MenuAction, {
          onCheckBoxChange: onCheckBoxChange,
          isAllSelected: isAllSelected,
          align: align,
          mobileHidden: mobileHidden,
          width: width
        }));
      }
      return null;
    }
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      className: `
                            ${styles[`align-${align}`] || ""} 
                            ${mobileHidden ? "" : styles["mobile"]} 
                            ${width ? styles[width] || "" : ""}
                        `,
      style: basis ? {
        flexBasis: basis
      } : adjustStickyTop && {
        width: "12.5rem"
      }
    }, label.map((text, i) => {
      const textElem = i === 0 || boldColumn ? /*#__PURE__*/React.createElement("h5", null, i18n`${text}`) : /*#__PURE__*/React.createElement("small", null, i18n`${text}`);
      const sortElementIndex = paramSort.findIndex(f => f.column === columnName);
      const orderClass = (paramSort[sortElementIndex] || {}).order;
      if (sortable) {
        return /*#__PURE__*/React.createElement("div", {
          key: i
        }, /*#__PURE__*/React.createElement("button", {
          onClick: () => updateSort(columnName),
          className: `${styles["sort-button"] || ""} ${orderClass ? styles["is-sorted"] : ""} ${styles[`align-sort-${align}`] || ""}`
        }, textElem, /*#__PURE__*/React.createElement(Icon, {
          className: `${styles[`icon-sort`]} ${styles[`sort${orderClass ? `-${orderClass}` : ""}`] || ""}`,
          name: `sort${orderClass ? `-${orderClass}` : ""}`
        })));
      }
      return /*#__PURE__*/React.createElement("div", {
        key: i
      }, textElem);
    }));
  }));
};
export default ListHeader;